export default __webpack_public_path__ + "static/media/accuracy_icon.a9ce6769.svg";